"use client";

import Link from "next/link";
import { ChevronRight } from "lucide-react";

import { toProductListItem } from "@/shared/api/services/productService";

import { ScrollCarousel } from "@/features/home/components/ScrollCarousel";
import { useNewProducts } from "@/features/home/queries/useHomeData";
import { ProductCard, ProductCardSkeleton } from "@/features/shopping/components/ProductCard";

export function NewProductsSection() {
  const { data, isLoading } = useNewProducts();
  const products = (data?.data?.products ?? []).map(toProductListItem);

  return (
    <section className="py-10 md:py-14">
      <div className="max-w-screen-xl mx-auto px-6">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <h2 className="font-heading text-base md:text-lg font-semibold tracking-tight">신제품</h2>
          <Link
            href="/shopping?idCategory=146&order=latest"
            className="flex items-center gap-0.5 text-xs text-neutral-400 hover:text-neutral-700 transition-colors"
          >
            전체 보기
            <ChevronRight className="w-3.5 h-3.5" />
          </Link>
        </div>

        {isLoading ? (
          <div className="flex gap-4 overflow-hidden">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="flex-shrink-0 w-[55%] md:w-[calc(20%-13px)]">
                <ProductCardSkeleton />
              </div>
            ))}
          </div>
        ) : (
          <ScrollCarousel>
            {products.map((product) => (
              <div
                key={product.id}
                className="flex-shrink-0 w-[55%] sm:w-[38%] md:w-[calc(20%-13px)]"
              >
                <ProductCard product={product} />
              </div>
            ))}
          </ScrollCarousel>
        )}
      </div>
    </section>
  );
}
